export const PlusIcon = ({ width, height, viewBox, fill, styles }) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox={viewBox || '0 0 24 24'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3.75C12.4142 3.75 12.75 4.08579 12.75 4.5V11.25H19.5C19.9142 11.25 20.25 11.5858 20.25 12C20.25 12.4142 19.9142 12.75 19.5 12.75H12.75V19.5C12.75 19.9142 12.4142 20.25 12 20.25C11.5858 20.25 11.25 19.9142 11.25 19.5V12.75H4.5C4.08579 12.75 3.75 12.4142 3.75 12C3.75 11.5858 4.08579 11.25 4.5 11.25H11.25V4.5C11.25 4.08579 11.5858 3.75 12 3.75Z"
      fill={fill || '#C1C1C1'}
    />
  </svg>
);
